import { useState } from 'react';

const FAQS = [
  {
    q: 'Do I need marketing experience to use AI ads for real estate?',
    a: 'Zero experience needed. AdForge is built for agents, not marketers. You answer a few plain-English questions about your listing or target market — property type, location, target buyer or seller — and the AI writes everything. No jargon, no learning curve.',
  },
  {
    q: 'What types of real estate professionals can use AdForge?',
    a: 'AdForge works for all real estate professionals: buyer\'s agents, listing agents, brokerages, property managers, mortgage brokers, new development sales teams, and commercial real estate agents. If you need to generate leads or promote listings, AdForge is built for you.',
  },
  {
    q: 'How much does real estate advertising with AdForge cost?',
    a: 'AdForge is free to start, no credit card required. Paid plans start at $29/month. Your actual Facebook or Google ad spend is separate and set by you directly in the ad platform.',
  },
  {
    q: 'How fast can I create real estate ads with AdForge?',
    a: 'Most agents generate their first complete ad package — including copy, headlines, hooks, and up to 6 AI-generated images — in under 3 minutes. It\'s the fastest way to go from a new listing to a live ad.',
  },
  {
    q: 'Can I create ads for both buyer leads and seller leads?',
    a: 'Yes. AdForge lets you create targeted ads for any goal — promoting a specific listing, generating seller leads with a home valuation offer, attracting first-time buyers, or building your personal brand as a local expert.',
  },
  {
    q: 'Does AdForge create Google ads for real estate too?',
    a: 'Yes. AdForge generates ad copy optimized for Facebook, Instagram, Google Ads, TikTok, and LinkedIn. You choose the platform and the AI formats everything correctly for it.',
  },
  {
    q: 'Do I need a designer for the ad images?',
    a: 'No. AdForge generates up to 6 professional AI images per run, sized and formatted for your chosen platform. No designer, no expensive photography, no Canva required.',
  },
  {
    q: 'Is AdForge better than hiring a real estate marketing agency?',
    a: 'For most agents, yes. Real estate marketing agencies charge $1,500–$6,000/month and take weeks to deliver. AdForge delivers a complete ad package in minutes for a fraction of the cost. You stay in control and can generate new ads for every listing.',
  },
];

export default function RealEstateFAQ() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section className="py-20 lg:py-24 bg-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-sm font-semibold text-orange-500 uppercase tracking-widest mb-3">
            FAQ
          </span>
          <h2 className="text-3xl lg:text-4xl font-black text-stone-900 mb-4 leading-tight">
            Questions About AI Ads for Real Estate
          </h2>
          <p className="text-base text-stone-500">
            Everything you need to know about using AdForge for your real estate advertising.
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {FAQS.map((faq, i) => (
            <div key={i} className="border border-stone-200 rounded-xl overflow-hidden">
              <button
                onClick={() => setOpenIdx(openIdx === i ? null : i)}
                className="w-full flex items-center justify-between gap-4 px-6 py-5 text-left cursor-pointer hover:bg-stone-50 transition-colors duration-200"
              >
                <h4 className="text-sm font-bold text-stone-900 leading-snug">
                  <a id={`faq-re-${i}`}>{faq.q}</a>
                </h4>
                <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                  <i className={`ri-${openIdx === i ? 'subtract' : 'add'}-line text-orange-500 text-lg`} />
                </div>
              </button>
              {openIdx === i && (
                <div className="px-6 pb-5">
                  <p className="text-sm text-stone-500 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>

        <div className="mt-10 text-center">
          <p className="text-sm text-stone-500">
            Still have questions?{' '}
            <a href="/contact" className="text-orange-500 font-semibold hover:underline">
              Contact our team →
            </a>
          </p>
        </div>
      </div>
    </section>
  );
}
